import { Injectable } from '@angular/core';
import { datadogRum, RumGlobal } from '@datadog/browser-rum';
import { AppConfigService } from './app-config.service';
import { AuthService } from 'src/app/auth/auth.service';
import { Profile } from '../models/profile';

@Injectable({
  providedIn: 'root',
})
export class DatadogRumService {
  public readonly rum: RumGlobal;
  constructor(private readonly authService: AuthService) {
    this.rum = datadogRum;
  }

  public init({ config, tenant }: Pick<AppConfigService, 'config' | 'tenant'>): void {
    const isAnEnvWhereWeDontWantToRunDataDog = ['dev', 'development'].includes(config.name) || Boolean((window as any)?.Cypress);
    if (isAnEnvWhereWeDontWantToRunDataDog) {
      return;
    }
    datadogRum.init({
      applicationId: '8a07d5d4-d151-4cdd-ad3e-8473848120be',
      clientToken: 'pubab7d6de67febcf84b03b9d5436c3ff98',
      service: 'lineup-ui',
      env: config.production ? 'lineup-prod' : config.staging ? 'lineup-staging' : 'lineup-dev',
      site: 'datadoghq.com',
      // Specify a version number to identify the deployed version of your application in Datadog
      version: config.version,
      sampleRate: 100,
      premiumSampleRate: 100,
      trackInteractions: true,
      defaultPrivacyLevel: 'mask-user-input',
      allowedTracingOrigins: [window?.location.origin],
    });
    datadogRum.startSessionReplayRecording();
    datadogRum.setRumGlobalContext({ tenant: { ...tenant } });
    this.authService.hasAuthenticated.subscribe(({ authenticated }) => {
      if (authenticated) {
        this.authService.getProfile().subscribe((profile: Profile) => {
          datadogRum.setUser({ id: profile.userId, name: profile.nickname });
        });
      } else {
        datadogRum.removeUser();
      }
    });
  }
}
